import { httpRequest } from "@/utils/HttpRequest";
import { IPage } from "@/types/FmsTypes";
import { getToken, getProdBaseRequestUrl, LONG_REQUEST_TIMEOUT } from "@/utils/constants";
import {
    InvoiceSummarySearch, InvoiceSummary,
    InvoiceBillSearch, InvoiceBill,
    wordsResults,
    InvoiceRecordSearch, InvoiceRecord,
    InvoiceApplySearch, InvoiceApply, InvoiceApplyApproval,
    InvoiceIdentify, InvoiceMateFields,
} from "./InvoiceManageTypes";

class InvoiceManageService {

    //客户发票列表
    async invoiceSummaryPage(searchVo: InvoiceSummarySearch) {
        const apiUrl = "/invoice/summary/page";
        return await httpRequest.post<IPage<InvoiceSummary>>(apiUrl, searchVo);
    }

    //客户发票汇总统计
    async invoiceSummary(searchVo: InvoiceSummarySearch) {
        const apiUrl = "/invoice/summary";
        return await httpRequest.post<InvoiceSummary>(apiUrl, searchVo);
    }

    //客户发票列表导出
    async invoiceSummaryExport(searchVo: InvoiceSummarySearch) {
        const apiUrl = "/invoice/summary/export";
        return await httpRequest.postFile(apiUrl, searchVo, { timeout: LONG_REQUEST_TIMEOUT });
    }

    //客户账单列表
    async invoiceBillPage(searchVo: InvoiceBillSearch) {
        const apiUrl = "invoice/bill/page";
        return await httpRequest.post<IPage<InvoiceBill>>(apiUrl, searchVo);
    }

    //md5列表
    async invoiceMd5(searchVo: InvoiceBillSearch) {
        const apiUrl = "invoice/bill/md5s";
        return await httpRequest.post<string[]>(apiUrl, searchVo);
    }

    //md5文件
    async invoiceMd5Export(url: string, data: any) {
        return await httpRequest.postFile(url, data, { timeout: LONG_REQUEST_TIMEOUT });
    }

    //发票单据汇总统计
    async invoiceBillSummary(searchVo: InvoiceBillSearch) {
        const apiUrl = "/invoice/bill/summary";
        return await httpRequest.post<InvoiceSummary>(apiUrl, searchVo);
    }

    //客户发票账单导出
    async invoiceBillExport(searchVo: InvoiceBillSearch) {
        const apiUrl = "/invoice/bill/export";
        return await httpRequest.postFile(apiUrl, searchVo, { timeout: LONG_REQUEST_TIMEOUT });
    }

    //发票识别接口
    async invoiceIdentification(url: string) {
        const apiUrl = "invoice/identification";

        const imageUrl = getProdBaseRequestUrl() + "/fsrv/fetch/" + url + "?Authorization=" + getToken() + "&imageMogr2/size-limit/3m";
        return await httpRequest.post<wordsResults>(apiUrl, { "url": imageUrl }, { timeout: LONG_REQUEST_TIMEOUT });
    }

    //开票记录查询
    async invoiceRecordPage(searchVo: InvoiceRecordSearch) {
        const apiUrl = "/invoice/invoiceRecord/page";
        return await httpRequest.post<IPage<InvoiceRecord>>(apiUrl, searchVo);
    }

    //无票记录查询
    async invoiceApplyPage(searchVo: InvoiceApplySearch) {
        const apiUrl = "invoice/apply/page";
        return await httpRequest.post<IPage<InvoiceApply>>(apiUrl, searchVo);
    }

    //无票收入保存
    async invoiceNoTicketIncome(billCodes: string[]) {
        const apiUrl = "invoice/noTicketIncome";
        return await httpRequest.post<IPage<InvoiceApply>>(apiUrl, billCodes);
    }

    //申请开票
    async invoiceApply(billCodes: string[]) {
        const apiUrl = "invoice/apply";
        return await httpRequest.post<IPage<InvoiceApply>>(apiUrl, billCodes);
    }

    //无票申请审核
    async invoiceApplyApproval(approval: InvoiceApplyApproval) {
        const apiUrl = "invoice/apply/approval";
        return await httpRequest.post<IPage<InvoiceApply>>(apiUrl, approval);
    }

    //发票上传
    async invoiceUploadInsert(list: InvoiceIdentify[]) {
        const apiUrl = "/invoice/batchInsert";
        return await httpRequest.post<boolean>(apiUrl, list);
    }

    //发票上传记录
    async invoiceUploadPage(searchVo: InvoiceBillSearch) {
        const apiUrl = "invoice/page";
        return await httpRequest.post<IPage<InvoiceIdentify>>(apiUrl, searchVo);
    }

    //发票修改
    async invoiceUploadUpdate(identify: InvoiceIdentify) {
        const apiUrl = "/invoice/update";
        return await httpRequest.post<boolean>(apiUrl, identify);
    }

    //发票删除
    async invoiceUploadDelete(id: string) {
        const apiUrl = "/invoice/delete/" + id;
        return await httpRequest.get<boolean>(apiUrl);
    }

    //发票修改
    async invoiceUploadMate(mate: InvoiceMateFields[]) {
        const apiUrl = "/invoice/billInvoiceMate";
        return await httpRequest.post<boolean>(apiUrl, mate);
    }

}

export const invoiceManageService = new InvoiceManageService();
